<script setup>
	import {
		ref,
		computed,
	} from 'vue';
	import { useStore } from 'vuex';
	import { track_show_gated_content } from 'shared/services/tracking/contentTrackingService';
	import { DsButton } from '@coloplast/design-system';
	import { isExternalUrl } from 'shared/services/urlTypeService';
	import initCampaignIdSFDC from 'shared/vanilla/initSendCampaignIDtoSFDC';

	const props = defineProps({
		vm: {
			type: Object,
			default: () => { },
		},
		isButtonGated: {
			type: String,
		},
		label: {
			type: String,
		},
		url: {
			type: String,
		},
		download: {
			type: Boolean,
		},
		name: {
			type: String,
			default: '',
		},
		isForDownload: {
			type: Boolean,
		},
	});

	const store = useStore();

	const
		isUserLoggedIn = computed(() => store.getters.getIsUserLoggedIn),
		isHcpUser = computed(() => store.getters.getIsHcpUser),
		shouldTrackId = computed(() => props?.vm?.BaseViewModel?.ShouldTrackSfdcCampaign),
		campaignId = ref(props.vm?.CurrentBlock?.CampaignId || props.vm?.CurrentPage?.CampaignId),
		campaignStatus = ref(props.vm?.CurrentBlock?.CampaignStatus || props.vm?.CurrentPage?.CampaignStatus),
		isButtonGatedBoolean = computed(() => props?.isButtonGated === 'True'),
		fileName = computed(() => props?.name || null),
		urlTarget = computed(() => isExternalUrl(props?.url) || props?.download ? '_blank' : '_self');

	function showContentGate() {
		store.commit('setContentGateIsShown', true);
		track_show_gated_content();
	}
</script>
<template>
	<DsButton
				v-if="isButtonGatedBoolean && !isUserLoggedIn && !isHcpUser"
				type="button"
				variant="primary"
				:icon-end="isForDownload ? 'download' : null"
				:click-handler="showContentGate"
				>
		{{ label }}
	</DsButton>
	<DsButton
				v-else
				:href="url"
				:download="fileName"
				:target="urlTarget"
				variant="primary"
				:icon-end="isForDownload ? 'download' : null"
				@click="shouldTrackId && initCampaignIdSFDC(campaignId, campaignStatus)"
				>
		{{ label }}
	</DsButton>
</template>
